import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, ViewContainerRef, EmbeddedViewRef, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { AnalyticsService } from '../../../../shared/providers/analytics.service';
import { ValidationService } from '../../../../shared/providers/validation.service';
import { ToastService } from '../../../../shared/providers/toast.service';
import { CommonService } from '../../../../shared/providers/common.service';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { PropertyListingService } from '../../../../shared/providers/property-listing.service';
import { IPropertyDetails } from '../../../../shared/models/propertydetails';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { IPropertyRentTermModel } from '../../../../shared/models/PropertyRentTermModel';
import { ContactType } from '../../../../shared/enum/enum';
import { ISaveRequestBov } from '../../../../shared/models/SaveRequestBov';

interface IAnalyticsDetails {
  Name: string;
  Value: string;
}

interface IPropertyData {
  Id: number;
  Name: string;
  Type: number;
}

interface IRequestedPropertyData {
  Id: number;
  Name: string;
  Guid: string;
  State: string;
  City: string;
  Price?: number;
  PropertyForId?: number;
  Source: string;
  Unpriced?: boolean;
  AccessAdded?: number;
}

interface IChartInput {
  TenantId: number;
  StartDate: Date;
  EndDate: Date;
  States: string[];
  PropertyType: number;
  Subcategory: number;
  PropertyId: number;
  Mode?: number;
  Id: number[];
  Type?: number;
  PropertyTypes: number[];
  Subcategories: number[];
  Source?: string;
}


@Component({
  selector: 'app-market-data-tab',
  templateUrl: './market-data.component.html',
  styleUrls: ['./market-data.component.css']
})

export class MarketDataComponent implements OnInit {

  chartInput = {} as IChartInput;
  propertyData: any[];
  StartDate: Date;
  EndDate: Date;

  propertyGuid: any;
  tenantId: number;
  property = {} as IPropertyDetails;
  propertyId: number;

  propertyTypes: IPropertyData[];
  propertyTypeSubcategorys: IPropertyData[];
  AvailableProperties: IRequestedPropertyData[];
  OffMarketProperties: IRequestedPropertyData[];
  propertyTypesList: any;
  subCategoriesList: any;
  isState: boolean = false;
  isActiveListing: boolean = true;
  isRemainingTerm: boolean = true;
  isSCActiveListing: boolean = true;
  PropertyTypeText: string = '';
  SubcategoryText: string = '';
  isFilteredData = false;
  analyticsDetails: any;
  minDate = null;
  maxDate = new Date();
  propertyDates: any;
  user: any;
  PropertyRentTerm: IPropertyRentTermModel[];
  inputCapRate: any;
  tenantAvgCapRate: any;
  contactType = ContactType;
  optionsCount: number;
  calculatedPrice: number;
  fromPage: string = this.router.url;
  defaultProfilePic: string;
  @Input() UserGuid: string;
  Is1031Accessed: boolean;
  Is1031OffMarketAccessed: boolean;
  BovRequest: ISaveRequestBov = {} as any;
  constructor(private Analytics: AnalyticsService, public Authentication: AuthenticationService, public Validation: ValidationService, private Toast: ToastService, public router: Router, private common: CommonService,
    private activatedRoute: ActivatedRoute, private Loader: LoaderService, private _propertyService: PropertyListingService) {

  }

  ngOnInit() {

    this.activatedRoute.params.subscribe(params => {
      if (params.id) {
        this.propertyGuid = params.id;

      }
    });
    this.UserGuid = this.UserGuid != '' && this.UserGuid != null ? this.UserGuid : '0000';
    this.user = this.Authentication.user;
    this.defaultProfilePic = '/assets/img/default-profile-img.png';
    this.loadPageContent();

  }

  marketData() {

    //this.Analytics.GetPropertyDates(this.tenantId).subscribe(x => {

    //  try {
    //    this.propertyDates = x;
    //    if (this.property.PropertyForId == 601) { // if property is in B+E listing then take date on market , if null then CreatedDate
    //      if (!this.Validation.IsinValid(this.propertyDates.DateOnMarket)) {
    //        this.minDate = this.Validation.convertUTCDateToLocalDate(this.propertyDates.DateOnMarket);
    //      }
    //      else if (!this.Validation.IsinValid(this.propertyDates.CreatedDate)) {
    //        this.minDate = this.Validation.convertUTCDateToLocalDate(this.propertyDates.CreatedDate);
    //      }
    //    }
    //    else { // if property is in 1031 listing then take CreatedDate
    //      if (!this.Validation.IsinValid(this.propertyDates.CreatedDate)) {
    //        this.minDate = this.Validation.convertUTCDateToLocalDate(this.propertyDates.CreatedDate);
    //      }
    //    }
    //  }
    //  catch { }
    //});

    this.chartInput.Type = 1;

    //this.Analytics.GetTypeAndSubcategoryOfProperty(this.chartInput).subscribe(x => {

    //  if (x != null && x.length > 0) {
    //    this.propertyData = x;
    //    this.propertyTypes = [];
    //    this.propertyTypeSubcategorys = [];
    //    this.propertyData.forEach(item => {
    //      if (item.Type == 1) {
    //        this.propertyTypes.push(item);
    //      }
    //      else {
    //        this.propertyTypeSubcategorys.push(item);
    //      }
    //    });

    //    this.setDefaultValues();
    //  }
    /*  this.bindType();*/

    /*});*/
    this.bindAnalyticsDetails();

  }

  onCapRateChange($event) {
    if (this.inputCapRate == null || this.inputCapRate == undefined) {
      this.calculatedPrice = 0;
    }
      if (this.inputCapRate > 0) {
        this.calculatedPrice = (this.property.NetOperatingIncome * 100) / this.inputCapRate;
        if (this.calculatedPrice > 0 && this.calculatedPrice != null) {
          this.calculatedPrice = parseFloat(this.calculatedPrice.toFixed(2))
        }
      }
      if (this.inputCapRate == 0) {
        this.calculatedPrice = 0;
      }
    }

  onAskingPriceChange() {

    if (this.calculatedPrice != null && this.calculatedPrice != undefined && this.calculatedPrice != 0) {
      let newAskingPrice = Number(this.calculatedPrice);
      let updatedCapRate = parseFloat(((this.property.NetOperatingIncome / newAskingPrice) * 100).toFixed(2));
        this.inputCapRate = updatedCapRate;
    }
    else {
      this.inputCapRate = null;
    }
  }


  onCalculatedPriceChange(data) {
    var cal = 0;
    this.inputCapRate = parseFloat(this.inputCapRate);
    if (data == 1) {
      cal = this.inputCapRate + .10;
    }

    if (data == 0) {
      cal = this.inputCapRate - .10;
    }
       
      if (cal > 0 || cal == 0) {

        if (data == 1) {
          this.inputCapRate = ((this.inputCapRate) + .10).toFixed(2);
          let calculatedvalue = (this.property.NetOperatingIncome / this.inputCapRate) * 100;
          if (calculatedvalue != null && calculatedvalue != undefined && calculatedvalue > 0) {
            calculatedvalue = parseFloat(calculatedvalue.toFixed(2))
          }
          this.calculatedPrice = calculatedvalue;
        }

        if (data == 0) {
          if (cal != 0) {

            let calculatedvalue = (this.property.NetOperatingIncome / this.inputCapRate) * 100;
            if (calculatedvalue != null && calculatedvalue != undefined && calculatedvalue > 0) {
              calculatedvalue = parseFloat(calculatedvalue.toFixed(2))
            }
            this.calculatedPrice = calculatedvalue;
          }
          if (this.inputCapRate > 0) {
            this.inputCapRate = ((this.inputCapRate) - .10).toFixed(2);
          }
          else {
            this.inputCapRate = (this.inputCapRate).toFixed(2);
          }
        }
        //this.inputCapRate = parseFloat(this.inputCapRate);
      }
      else {
        this.inputCapRate = parseFloat('0.00').toFixed(2);
      }
  }

  loadPageContent() {

    this._propertyService.getDataEntryPropertyDetails(this.propertyGuid, this.user.Id).subscribe(response => {
      if (response != null) {

        this.property = response;
        this.property.IsDEProperty = true;
        this.propertyGuid = response.Guid;

        this.tenantId = response.TenantId;
        this.propertyId = response.Id;
        this.chartInput.Id = [];


        this.chartInput.Id.push(response.Id);
        this.chartInput.TenantId = response.TenantId;
        this.chartInput.PropertyId = response.Id;
        this.chartInput.StartDate = this.Validation.utcify(this.StartDate);
        this.chartInput.EndDate = this.Validation.utcify(this.EndDate);
        this.chartInput.StartDate = new Date();
        this.chartInput.EndDate = new Date();
        this.chartInput.States = null;

        response.LeaseCommencementDate = this.Validation.convertUTCDateToLocalDate(response.LeaseCommencementDate);
        response.LeaseExpirationDate = this.Validation.convertUTCDateToLocalDate(response.LeaseExpirationDate);
        this.property.Remaining_Term = this.Validation.getRemainingTerm(response.LeaseExpirationDate, response.LeaseCommencementDate);

        this.marketData();
        this.loadRentTerm();
        if (this.Authentication.Admin() || this.Authentication.SuperAdmin()) {
          this.getProperties();
        }
        else {
          if (this.property.AvailablePropertyApproval || this.property.OfferMarketPropertyApproval) {
            this.getProperties();
          }
        }
        this.Loader.display(false);
      }
    });
  }

  showRentTermOptions(index) {
    var status = false;
    var count = 0;
    if (index == 0) {
      this.optionsCount = 0;
    }
    this.PropertyRentTerm.forEach(res => {
      if (res.IsOptional) {
        if (count == index && this.optionsCount == 0) {
          status = true
          this.optionsCount = 1
        }
      }
      count++;
    })
    return status;
  }

  showCurrentDate(currentitem) {
    let date = new Date();
    var status = false;
    if (currentitem.LeaseStartDate <= date && currentitem.LeaseEndDate >= date) {
      status = true;
    }

    return status;
  }

  setDefaultValues() {
    if (!this.isFilteredData) {
      this.chartInput.PropertyType = this.propertyTypes[0].Id;
      this.chartInput.Subcategory = this.propertyTypeSubcategorys.length > 0 ? this.propertyTypeSubcategorys[0].Id : 0;
    }
    else {
      this.StartDate = new Date(this.chartInput.StartDate);
      this.EndDate = new Date(this.chartInput.EndDate);
    }
    this.PropertyTypeText = this.propertyTypes.find(x => x.Id == this.chartInput.PropertyType).Name;
    this.SubcategoryText = this.propertyTypeSubcategorys.length > 0 ? this.propertyTypeSubcategorys.find(x => x.Id == this.chartInput.Subcategory).Name : '';
  }

  bindType() {
    this.common.getTypeList().subscribe(response => {
      let data = response;
      this.propertyTypesList = [];
      if (this.propertyTypes != null) {

        data.forEach(item => {
          if (this.propertyTypes.findIndex(x => x.Id == item.Id) > -1) {
            this.propertyTypesList.push(item);
          }
        });

        this.bindSubcategory();
      }
    });
  }

  contactBroker() {
    this._propertyService.contactBroker(this.user.Id, this.propertyId).subscribe(response => {
      this.Toast.addToast({
        title: 'Success',
        msg: `Your request has been successfully submitted. The B+E team will get in touch with you shortly`,
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
    });
  }

  RequestBov() {
    this.Loader.display(true);
    this.property.BovRequestId = 1
    let Ids = [];
    Ids.push(this.property.Guid)
    this.BovRequest.PropertyIds = Ids;
    this.BovRequest.SellerId = this.user.Id;
    this.BovRequest.UserGuid = this.UserGuid;
    this._propertyService.SavePortfolioBov(this.BovRequest).subscribe(res => {
      if (res["Success"]) {
        this.Loader.display(false);
        this.property.BovRequestId = 1;
        this.Toast.addToast({ title: 'Success', msg: 'BOV Requested successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      }
      else {
        this.property.BovRequestId = 0;
        this.Loader.display(false);
        this.Toast.addToast({ title: 'Error Occurred', msg: res["ReturnMsg"], timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
  }

  bindSubcategory() {
    //let propertyTypeList = [];
    //propertyTypeList.push(this.chartInput.PropertyType);
    //this.common.getSubcategoryList(propertyTypeList).subscribe(res => {
    //  let data = res;
    //  this.subCategoriesList = [];
    //  data.forEach(item => {
    //    if (this.propertyTypeSubcategorys.findIndex(x => x.Id == item["Id"]) > -1) {
    //      this.subCategoriesList.push(item);
    //    }
    //  });
    //  if (!this.isFilteredData) {
    //    this.chartInput.Subcategory = this.subCategoriesList.length > 0 ? this.subCategoriesList[0]["Id"] : 0;
    //  }
    //});
  }

  bindAnalyticsDetails() {
    ////this.setCurrentDates();
    //// this.setFilters();
    this.chartInput.Source = "MyPortfolioProperty";
    this.Analytics.GetAnalyticsDetails(this.chartInput).subscribe(response => {
      console.log(response);
      this.analyticsDetails = response;
      if (response != null && response != undefined) {
        let tenantCapRate = this.analyticsDetails.find(c => c.Name == 'TenantCapRate').Value;
        if (tenantCapRate == null || tenantCapRate == '-') {
          tenantCapRate = 0.00;
        }
        this.analyticsDetails = this.analyticsDetails.filter(c => c.Name != 'TenantCapRate');
        let newcaprate = parseFloat(tenantCapRate).toFixed(2);
        this.inputCapRate = newcaprate;
        this.tenantAvgCapRate = newcaprate;
        if (this.inputCapRate > 0) {
          let calculatedvalue = (this.property.NetOperatingIncome * 100) / this.inputCapRate;
          if (calculatedvalue != null && calculatedvalue != undefined && calculatedvalue > 0) {
            calculatedvalue = parseFloat(calculatedvalue.toFixed(2))
          }
          this.calculatedPrice = calculatedvalue;
        }
        else {
          let capRateDefault = 0;
          let calculatedvalue = parseFloat(capRateDefault.toFixed(2))
          this.calculatedPrice = calculatedvalue;
        }
      }

    });
  }


  loadRentTerm() {

    this._propertyService.GetDataEntryPropertyRentTermTable(this.propertyId).subscribe(res => {

      if (res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          res[i].LeaseStartDate = this.Validation.convertUTCDateToLocalDate(res[i].LeaseStartDate);
          res[i].LeaseEndDate = this.Validation.convertUTCDateToLocalDate(res[i].LeaseEndDate);
        }

        this.PropertyRentTerm = res;
        this.saveRentTermDetails();
      }

    });

  }

  saveRentTermDetails() {
    this.PropertyRentTerm.forEach(item => {
      item.NetOperatingIncome = Math.round(item.NetOperatingIncome);
    });
  }


  setCurrentDates() {
    if (!this.isFilteredData) {
      this.EndDate = new Date();
      this.StartDate = new Date();
    }
  }



  setFilters() {
    this.chartInput.TenantId = this.tenantId;
    this.chartInput.PropertyId = this.property.Id;
    this.chartInput.StartDate = this.Validation.utcify(this.StartDate);
    this.chartInput.EndDate = this.Validation.utcify(this.EndDate);
    this.chartInput.StartDate = this.StartDate;
    this.chartInput.EndDate = this.EndDate;
    this.chartInput.States = null;
  }


  tenantBreakdown = [];
  showTenantBreakdown = false;
  bindTenantBreakdown() {
    this.setFilters();
    this.Analytics.GetTenantBreakdown(this.chartInput).subscribe(response => {
      this.tenantBreakdown = response;
      this.showTenantBreakdown = true;
    });
  }

  selectedPropertyType = 0;
  marketDatatSummary = [];
  marketDatatSummaryTotal = [];

  bindMarketDatatSummary() {
    this.setFilters();
    let input = this.chartInput;
    input.PropertyType = this.selectedPropertyType;
    this.marketDatatSummary = [];
    this.marketDatatSummaryTotal = [];
    this.Analytics.GetMarketDatatSummary(input).subscribe(response => {
      this.marketDatatSummary = response.filter(x => x["RowNumber"] == 1);
      if (this.marketDatatSummary.length > 0) {
        this.marketDatatSummaryTotal = response.filter(x => x["RowNumber"] == 2);
      }
    });
  }

  SendPropertyAccessRequest(source: string) {
    this.Loader.display(true);
    this._propertyService.SendPropertyAccessRequest(this.user.Id, this.propertyId, this.UserGuid, source).subscribe(res => {
      this.Loader.display(false);
      this.Toast.addToast({
        title: 'Success',
        msg: `Your request has been successfully submitted. The B+E team will get in touch with you shortly`,
        timeout: 7000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
    });
  }

  getProperties() {
    if (this.property != null && this.property.TenantId > 0) {
      this._propertyService.getRequestedProperties(this.user.Id, this.property.TenantId, this.UserGuid).subscribe(res => {
        let response = res;
        if (response != null && response.length > 0) {
          this.AvailableProperties = response.filter(f => f['Source'] == 'Available');
          this.OffMarketProperties = response.filter(f => f['Source'] == 'Off-Market');
          if (this.AvailableProperties != null && this.AvailableProperties.length > 0) {
            let currentRow = this.AvailableProperties.filter(f => f.PropertyForId == 602)[0];
            if (currentRow != null && currentRow != undefined) {
              if (currentRow['AccessAdded'] == 0) {
                this.Is1031Accessed = false;
              }
              else {
                this.Is1031Accessed = true;
              }
            }
            else {
              this.Is1031Accessed = false;
            }
          }
          else {
            this.AvailableProperties = [];
            this.Is1031Accessed = false;
          }
          if (this.OffMarketProperties != null && this.OffMarketProperties.length > 0) {
            let currentRow = this.OffMarketProperties.filter(f => f.PropertyForId == 602)[0];
            if (currentRow != null && currentRow != undefined) {
              if (currentRow['AccessAdded'] == 0) {
                this.Is1031OffMarketAccessed = false;
              }
              else {
                this.Is1031OffMarketAccessed = true;
              }
            }
            else {
              this.Is1031OffMarketAccessed = false;
            }
          }
          else {
            this.OffMarketProperties = [];
            this.Is1031OffMarketAccessed = false;
          }
        }
        else {
          this.AvailableProperties = [];
          this.OffMarketProperties = [];
          this.Is1031Accessed = false;
          this.Is1031OffMarketAccessed = false;
        }
      });
    }
    else {
      this.AvailableProperties = [];
      this.OffMarketProperties = [];
      this.Is1031Accessed = false;
      this.Is1031OffMarketAccessed = false;
    }
  }

  Send1031AccessRequest(propertyId: number, source: string) {
    this.Loader.display(true);
    this._propertyService.Send1031AccessRequest(this.user.Id, propertyId, source).subscribe(res => {
      this.Loader.display(false);
      this.Toast.addToast({
        title: 'Success',
        msg: `Your request has been successfully submitted. The B+E team will get in touch with you shortly`,
        timeout: 7000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
    });
  }
}
